export default __webpack_public_path__ + "static/media/trade-insights.375bc502.svg";